var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041D\\u0430\\u0432\\u0447._\\u0437\\u0430\\u043A\\u043B\\u0430\\u0434\\u0438",
    "data-name": "\\u041D\\u0430\\u0432\\u0447. \\u0437\\u0430\\u043A\\u043B\\u0430\\u0434\\u0438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.995,
    height: 13.404,
    viewBox: "0 0 16.995 13.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1659",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1659",
    d: "M2.332,61.8V57.06L8.5,59.7l8.5-3.642L8.5,52.419,0,56.061l1.3.559V61.8A1.544,1.544,0,0,0,.277,63.254v2.569H3.36V63.254A1.544,1.544,0,0,0,2.332,61.8Z",
    transform: "translate(0 -52.419)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1660",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1660",
    d: "M113.079,239.84v2.678l4.624,2.312,4.624-2.312V239.84l-4.624,1.982Z",
    transform: "translate(-109.206 -233.42)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.bda80082231d2bbdd5f325232e1698ec.svg";
export { ForwardRef as ReactComponent };